import React from "react";

export function getWebImageVariantUrl(source) {
  const original = String(source || "").trim();
  if (!original) return "";

  const match = original.match(/^([^?#]*)(\?[^#]*)?(#.*)?$/);
  const path = match?.[1] || original;
  const query = match?.[2] || "";
  const hash = match?.[3] || "";

  if (/_web\.webp$/i.test(path)) return original;
  if (!/\.(png|jpe?g|webp|gif|bmp|tiff?)$/i.test(path)) return original;

  return (
    path.replace(/\.(png|jpe?g|webp|gif|bmp|tiff?)$/i, "_web.webp") +
    query +
    hash
  );
}

const OptimizedConfigImage = React.forwardRef(function OptimizedConfigImage(
  { src, onError, ...props },
  ref
) {
  const originalSource = String(src || "").trim();
  const optimizedSource = getWebImageVariantUrl(originalSource);
  const canTryOptimized =
    Boolean(originalSource) && optimizedSource !== originalSource;
  const [useOriginal, setUseOriginal] = React.useState(!canTryOptimized);

  React.useEffect(() => {
    setUseOriginal(!canTryOptimized);
  }, [canTryOptimized, optimizedSource, originalSource]);

  const currentSource = useOriginal ? originalSource : optimizedSource;

  return (
    <img
      {...props}
      ref={ref}
      src={currentSource}
      onError={(event) => {
        if (!useOriginal && originalSource) {
          setUseOriginal(true);
          return;
        }
        onError?.(event);
      }}
    />
  );
});

export default OptimizedConfigImage;
